
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"25","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.245 8.261h-8.158a.652.652 0 00-.652.652v2.606c0 .36.292.652.652.652h4.594a6.132 6.132 0 01-2.64 3.094l1.96 3.39c3.141-1.817 5-5.005 5-8.575 0-.508-.038-.871-.113-1.28a.655.655 0 00-.643-.539z","fill":"#52B788"}}),_c('path',{attrs:{"d":"M10 16.087a6.086 6.086 0 01-5.265-3.046l-3.39 1.954A9.987 9.987 0 0015 18.66v-.004l-1.959-3.391a6.041 6.041 0 01-3.04.822z","fill":"#74C69D"}}),_c('path',{attrs:{"d":"M3.913 10c0-1.108.302-2.145.822-3.04l-3.39-1.955A9.896 9.896 0 000 10c0 1.819.488 3.525 1.344 4.995l3.391-1.954A6.042 6.042 0 013.913 10z","fill":"#52B788"}}),_c('path',{attrs:{"d":"M10 3.913c1.466 0 2.813.521 3.865 1.388a.65.65 0 00.874-.04l1.846-1.846a.657.657 0 00-.037-.961A9.97 9.97 0 0010 0a9.987 9.987 0 00-8.656 5.005l3.391 1.954A6.086 6.086 0 0110 3.913z","fill":"#74C69D"}}),_c('path',{attrs:{"d":"M13.864 5.3a.65.65 0 00.875-.039l1.846-1.846a.657.657 0 00-.037-.961A9.97 9.97 0 0010 0v3.913c1.466 0 2.813.521 3.864 1.388z","fill":"#95D5B2"}})])
          )
        }
      }
    